import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {EdituserclientPage} from "../../pages/edituserclient/edituserclient";
import { RicercautenticlientPage } from "../../pages/ricercautenticlient/ricercautenticlient";

/**
 * Generated class for the UtenticlientPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-utenticlient',
  templateUrl: 'utenticlient.html',
})
export class UtenticlientPage {
  users;
  numero;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,

    public rest: RestApiProvider
  ) {

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad UtenticlientPage');
  }

  getUsers() {
    this.rest.getUsersListClient().subscribe(
      users => this.users = users,
      error => this.errorMessage = <any>error);
  }
  getNumeroUtenti() {
    this.rest.getNumeroUtenti().subscribe(
      numero => this.numero = numero,
      error => this.errorMessage = <any>error);
  }
  ionViewWillEnter () {
    this.getUsers();
    this.getNumeroUtenti();

  }
  edit(user){
    this.navCtrl.push(EdituserclientPage, { userclient: user});

  }
  search(){
    this.navCtrl.push(RicercautenticlientPage);

  }
  

}



// WEBPACK FOOTER //
// ./src/pages/utenticlient/utenticlient.ts